import React from 'react';
import Header from '../components/header.component';
import { AccountAccess } from '../components/account-access.component';
import { Footer } from '../components/footer.component';
import SectionHeader from '../components/common';
import { useTranslation } from 'react-i18next';
import '../scss/about-us.style.scss';
import AboutUsComponent from '../components/about-us.component';
import SEOMetadataComponent from '../components/seo-metadata.component';
import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from "../../common/FunctionUtils";
const AboutUsPage: React.FC = () => {
    const { t, i18n } = useTranslation();

    const currentLanguage = i18n.language;

    const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;
    const canonicalUrl = isEnglish
        ? `https://www.invozio.com/about-invozio?lang=${LOCALES.EN_US}`
        : `https://www.invozio.com/om-invozio?lang=${LOCALES.SV_SE}`;


    const schemaMarkup = getSchemaMarkup("om-invozio");
    return (
        <>
            <Header />
            <SEOMetadataComponent
                title={t('About Us')}
                // description={t('FEATURES_MAIN_DESCRIPTION')}
                canonicalUrl={canonicalUrl}
                noindex={false}
                robots="index, follow"
                schemaMarkup={schemaMarkup}
            />
            <SectionHeader
                titleKey={t('About Us')}
                subtitleKey={t("Welcome to Invozio, Sweden's most comprehensive platform for freelancers.")}
                className="invozio-news-section"
                titleClassName="main-title"
                subtitleClassName="sub-title"
                alignment="center"
            />
            <AboutUsComponent />
            <div className="bg-footer">
                <Footer />
            </div>
        </>
    );
};


export default AboutUsPage;
